// extracted by mini-css-extract-plugin
export default {"bar":"Bars_bar__pFR1Y"};